import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabOutcome from '../../form-fields/tab-outcome/tab-outcome';
class EditViewClientTabOutcome extends Component {
  render() {
    return (
      <div>
         <FormFieldsTabOutcome {...this.props} locked={true} />
      </div>
    );
  }
}
EditViewClientTabOutcome.propTypes = {
  locked: PropTypes.bool,
}
EditViewClientTabOutcome = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabOutcome);
export default EditViewClientTabOutcome;